// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendor-product-mapping-wrap {
  border-radius: 14px;
  border: 3px solid #FFF;
  background: #FFF;
  box-shadow: 0px 0px 20px 0px rgba(177, 197, 224, 0.1);
  margin-block: 20px 32px;
}
.vendor-product-mapping-wrap input::-webkit-search-cancel-button {
  display: none;
}
.vendor-product-mapping-table {
  padding-inline: 20px;
}
.vendor-product-mapping-table tr.mat-row.mat-mdc-no-data-row td {
  padding-top: 15px;
  text-align: center;
}
.vendor-product-mapping-table .vendor-bilddit-product-img-name-grp {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-block: 30px;
}
.vendor-product-mapping-table .erp-edit-add-btn-header {
  text-align: center;
}
.vendor-product-mapping-table .previous-requested-price {
  text-align: center;
}
.vendor-product-mapping-table .vendor-erp-product-title,
.vendor-product-mapping-table .vendor-bilddit-product-title {
  max-width: 140px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.vendor-product-mapping-table .erp-edit-add-mapping {
  text-align: center;
}
.vendor-product-mapping-table .edit-map-wrap {
  display: flex;
  justify-content: center;
}
.vendor-product-mapping-table .product-request {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.vendor-product-mapping-table .product-request-btn-wrap {
  color: #3E7028;
  text-align: left;
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  padding-top: 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.vendor-product-mapping-table .product-request-btn-wrap button {
  color: #3E7028;
  text-align: right;
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}
.vendor-product-mapping-table .product-request-msg {
  color: #4C5258;
  text-align: center;
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}
.vendor-product-mapping-table .vendor-erp-product-img-name-grp {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-block: 30px;
}
.vendor-product-mapping-table .vendor-erp-product-img,
.vendor-product-mapping-table .vendor-bilddit-product-img {
  width: 55px;
  height: 55px;
  padding: 10px 6px;
  border-radius: 6px;
  background: #F8F8F8;
}
.vendor-product-mapping-table tr td {
  color: #333;
}
.vendor-product-mapping-table button.epr-product-mapping-edit-btn div:first-child {
  padding-top: 1px;
}
.vendor-product-mapping-table button.epr-product-mapping-edit-btn div {
  display: flex;
}
.vendor-product-mapping-table button.epr-product-mapping-edit-btn {
  display: flex;
  align-items: center;
  color: #6ECB44;
  text-align: center;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.12px;
  text-decoration-line: underline;
  padding: 0;
}
.vendor-product-mapping-table button.epr-product-add-mapping-btn {
  background: #6ECB44;
  color: #fff;
  text-align: center;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.12px;
  padding: 2px 12px;
}
.vendor-product-mapping-header {
  padding-inline: 20px;
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
}
.vendor-product-mapping-header-text {
  color: #333333;
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.vendor-product-mapping-vendor-name {
  color: #7D7D7D;
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
}
.vendor-product-mapping-wrap-body {
  margin-inline: -3px;
  padding-block: 20px 25px;
}
.vendor-product-mapping-seperator {
  background: #F8F9FA;
  height: 20px;
  width: 100%;
}
.vendor-product-mapping-filter-wrap .data_filter {
  display: flex;
  gap: 10px;
  width: 100%;
}
.vendor-product-mapping-filter-wrap .data_filter div {
  width: 100%;
}

@media screen and (max-width: 960px) {
  .vendor-product-mapping-wrap {
    background: #F5F4F7;
    border: none;
    box-shadow: none;
  }
  .vendor-product-mapping-header {
    display: block;
    border-radius: 14px;
    border: 3px solid #FFF;
    background: #FFF;
    box-shadow: 0px 0px 20px 0px rgba(177, 197, 224, 0.1);
    padding: 20px 15px;
  }
  .vendor-product-mapping-seperator {
    display: none;
  }
  .vendor-product-mapping-filter-wrap {
    margin-top: 10px;
  }
  .vendor-product-mapping-table {
    padding-inline: 0;
  }
  .vendor-product-mapping-table tr td {
    color: #333;
    min-height: 70px;
    display: flex;
    align-items: center;
  }
  .vendor-product-mapping-table tr td:last-child {
    min-height: 40px;
  }
  .vendor-product-mapping-table .vendor-bilddit-product-img-name-grp {
    padding-block: 0px;
  }
  .vendor-product-mapping-table .vendor-erp-product-title,
  .vendor-product-mapping-table .vendor-bilddit-product-title {
    text-align: right;
    max-width: 120px;
  }
}
@media screen and (max-width: 592px) {
  .vendor-product-mapping-header {
    display: block;
  }
  .vendor-product-mapping-filter-wrap {
    margin-top: 10px;
  }
  .vendor-product-mapping-filter-wrap .data_filter {
    flex-direction: column;
  }
  .vendor-product-mapping-filter-wrap .data_filter div {
    width: 100%;
  }
  .vendor-product-mapping-table .vendor-erp-product-title,
  .vendor-product-mapping-table .vendor-bilddit-product-title {
    text-align: right;
  }
  .vendor-product-mapping-table .vendor-bilddit-product-img-name-grp,
  .vendor-product-mapping-table .vendor-erp-product-img-name-grp {
    gap: 2px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/products/merchant-product-mapping/merchant-product-mapping.component.scss"],"names":[],"mappings":"AAEI;EAEI,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,qDAAA;EACA,uBAAA;AAFR;AAIQ;EACI,aAAA;AAFZ;AAMI;EACI,oBAAA;AAJR;AAKQ;EACI,iBAAA;EACA,kBAAA;AAHZ;AAKQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAHZ;AAKQ;EACI,kBAAA;AAHZ;AAKQ;EACI,kBAAA;AAHZ;AAKQ;;EAEI,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHZ;AAKQ;EACI,kBAAA;AAHZ;AAKQ;EACI,aAAA;EACA,uBAAA;AAHZ;AAKQ;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAHZ;AAKQ;EACI,cAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAHZ;AAIY;EACI,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAFhB;AAKQ;EACI,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAHZ;AAMQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAJZ;AAMQ;;EAEI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAJZ;AAMQ;EACI,WAAA;AAJZ;AAMQ;EACI,gBAAA;AAJZ;AAMQ;EACI,aAAA;AAJZ;AAMQ;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,+BAAA;EACA,UAAA;AAJZ;AAMQ;EACI,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AAJZ;AAOI;EACI,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;AALR;AAOQ;EACI,cAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AALZ;AAQI;EACI,cAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AANR;AAQI;EACI,mBAAA;EACA,wBAAA;AANR;AAQI;EACI,mBAAA;EACA,YAAA;EACA,WAAA;AANR;AAQI;EACI,aAAA;EACA,SAAA;EACA,WAAA;AANR;AAOQ;EACI,WAAA;AALZ;;AAUA;EAGQ;IACI,mBAAA;IACA,YAAA;IACA,gBAAA;EATV;EAWM;IACI,cAAA;IACA,mBAAA;IACA,sBAAA;IACA,gBAAA;IACA,qDAAA;IACA,kBAAA;EATV;EAWM;IACI,aAAA;EATV;EAWM;IACI,gBAAA;EATV;EAWM;IACI,iBAAA;EATV;EAUU;IAEI,WAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;EATd;EAWU;IACI,gBAAA;EATd;EAWU;IACI,kBAAA;EATd;EAWU;;IAEI,iBAAA;IACA,gBAAA;EATd;AACF;AAaA;EAGQ;IACI,cAAA;EAbV;EAeM;IACI,gBAAA;EAbV;EAcU;IACI,sBAAA;EAZd;EAac;IACI,WAAA;EAXlB;EAgBU;;IAEI,iBAAA;EAdd;EAgBU;;IAGI,QAAA;EAfd;AACF","sourcesContent":[".vendor-product-mapping\n{\n    &-wrap \n    {\n        border-radius: 14px;\n        border: 3px solid #FFF;\n        background: #FFF;\n        box-shadow: 0px 0px 20px 0px rgba(177, 197, 224, 0.10);\n        margin-block: 20px 32px;\n\n        input::-webkit-search-cancel-button{\n            display: none;\n        }\n    }\n    \n    &-table{\n        padding-inline: 20px;\n        tr.mat-row.mat-mdc-no-data-row td {\n            padding-top: 15px;\n            text-align: center;\n        }\n        .vendor-bilddit-product-img-name-grp {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            padding-block: 30px;\n        }\n        .erp-edit-add-btn-header{\n            text-align: center;\n        }\n        .previous-requested-price {\n            text-align: center;\n        }\n        .vendor-erp-product-title,\n        .vendor-bilddit-product-title {\n            max-width: 140px;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            font-family:  var(--font-family);\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: normal;\n        }\n        .erp-edit-add-mapping{\n            text-align: center;\n        }\n        .edit-map-wrap{\n            display: flex;\n            justify-content: center;\n        }\n        .product-request{\n            text-align: center;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n        }\n        .product-request-btn-wrap {\n            color: #3E7028;\n            text-align: left;\n            font-family:  var(--font-family);\n            font-size: 11px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 14px;\n            padding-top: 0px;\n            display: flex;\n            align-items: center;\n            justify-content: flex-start;\n            button{\n                color: #3E7028;\n                text-align: right;\n                font-family:  var(--font-family);\n                font-size: 11px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: 14px;\n            }\n        }\n        .product-request-msg {\n            color: #4C5258;\n            text-align: center;\n            font-family:  var(--font-family);\n            font-size: 11px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 14px;\n        }\n        \n        .vendor-erp-product-img-name-grp {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            padding-block: 30px;\n        }\n        .vendor-erp-product-img,\n        .vendor-bilddit-product-img {\n            width: 55px;\n            height: 55px;\n            padding: 10px 6px;\n            border-radius: 6px;\n            background: #F8F8F8;\n        }\n        tr td {\n            color: #333;\n        }\n        button.epr-product-mapping-edit-btn div:first-child {\n            padding-top: 1px;\n        }\n        button.epr-product-mapping-edit-btn div {\n            display: flex;\n        }\n        button.epr-product-mapping-edit-btn {\n            display: flex;\n            align-items: center;\n            color: #6ECB44;\n            text-align: center;\n            font-family:  var(--font-family);\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 20px;\n            letter-spacing: 0.12px;\n            text-decoration-line: underline;\n            padding: 0;\n        }\n        button.epr-product-add-mapping-btn {\n            background: #6ECB44;\n            color: #fff;\n            text-align: center;\n            font-family:  var(--font-family);\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 20px;\n            letter-spacing: 0.12px;\n            padding: 2px 12px;\n        }\n    }\n    &-header{\n        padding-inline: 20px;\n        display: flex;\n        justify-content: space-between;\n        padding-bottom: 20px;\n\n        &-text {\n            color: #333333;\n            font-family:  var(--font-family);\n            font-size: 18px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: normal;\n        }\n    }\n    &-vendor-name {\n        color: #7D7D7D;\n        font-family:  var(--font-family);\n        font-size: 11px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 26px;\n    }\n    &-wrap-body {\n        margin-inline: -3px;\n        padding-block: 20px 25px;\n    }\n    &-seperator{\n        background: #F8F9FA;\n        height: 20px;\n        width: 100%;\n    }\n    &-filter-wrap .data_filter {\n        display: flex;\n        gap: 10px;\n        width: 100%;\n        div {\n            width: 100%;\n        }\n    }\n}\n\n@media screen and (max-width:960px) {\n    .vendor-product-mapping\n    {\n        &-wrap{\n            background: #F5F4F7;  \n            border: none;\n            box-shadow: none;\n        }\n        &-header{\n            display: block;\n            border-radius: 14px;\n            border: 3px solid #FFF;\n            background: #FFF;\n            box-shadow: 0px 0px 20px 0px rgba(177, 197, 224, 0.10);\n            padding: 20px 15px;\n        }\n        &-seperator{\n            display: none;\n        }\n        &-filter-wrap{\n            margin-top: 10px;\n        }\n        &-table{\n            padding-inline: 0;\n            tr td\n            {\n                color: #333;\n                min-height: 70px;\n                display: flex;\n                align-items: center;\n            }\n            tr td:last-child{\n                min-height: 40px;\n            }\n            .vendor-bilddit-product-img-name-grp {\n                padding-block: 0px;\n            }\n            .vendor-erp-product-title,\n            .vendor-bilddit-product-title {\n                text-align: right;\n                max-width: 120px;\n            }\n        }\n    }\n}\n@media screen and (max-width:592px) {\n    .vendor-product-mapping\n    {\n        &-header{\n            display: block;\n        }\n        &-filter-wrap{\n            margin-top: 10px;\n            .data_filter{\n                flex-direction: column;\n                div{\n                    width: 100%;\n                }\n            }\n        }\n        &-table{\n            .vendor-erp-product-title,\n            .vendor-bilddit-product-title {\n                text-align: right;\n             }\n            .vendor-bilddit-product-img-name-grp,\n            .vendor-erp-product-img-name-grp\n            {\n                gap: 2px;\n            }\n        }\n\n       \n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
